
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import { VForm } from '@/types/Components';
    import { DeleteTerminplatzPayload, UpdateTerminplatzPayload } from '@/store/terminplaetze';
    import {Terminplatz} from '@/types/Terminkalender';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('terminplaetze', ['loaders']),
            ...mapState('authentication', ['impfstelle_id']),
        },
        methods: {
            ...mapActions('terminplaetze', ['updateTerminplatz', 'deleteTerminplatz']),
        },
    })
    export default class terminplatzenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() terminplatz!: Terminplatz;

        public $refs!: {
            form: VForm;
        };

        public updateTerminplatz!: (payload: UpdateTerminplatzPayload) => void;
        public deleteTerminplatz!: (payload: DeleteTerminplatzPayload) => void;

        public colorMenu = false;
        public colorTextMenu = false;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateTerminplatz({ terminplatz: this.terminplatz});
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Terminplatz endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteTerminplatz({ terminplatz: this.terminplatz});
                    }
                });
        }
    }
